export default __webpack_public_path__ + "static/media/r1.cc632bdb.svg";